import { render, staticRenderFns } from "./CTC.vue?vue&type=template&id=576bbffa"
import script from "./CTC.vue?vue&type=script&lang=js"
export * from "./CTC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports